import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorDashboardClassesReadSlice = createSlice({
  name: "TutorDashboardClassesReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorDashboardClassesRead: (state) => {
      state.isLoading = true;
    },
    successTutorDashboardClassesRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorDashboardClassesRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorDashboardClassesRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorDashboardClassesRead,
  successTutorDashboardClassesRead,
  failureTutorDashboardClassesRead,
  clearTutorDashboardClassesRead,
} = TutorDashboardClassesReadSlice.actions;

export default TutorDashboardClassesReadSlice.reducer;
